import { Link } from "react-router-dom";
import { HelpLayout } from "@/components/help/HelpLayout";
import { getArticlesBySection } from "@/lib/help/manifest";
import { SeoHead } from "@/components/SeoHead";
import { MarketingNav } from "@/components/marketing/MarketingNav";
import { MarketingFooter } from "@/components/marketing/MarketingFooter";

const HelpIndex = () => {
  const sections = getArticlesBySection();
  return (
    <div className="min-h-screen bg-background text-foreground">
      <SeoHead title="Knowledge Base" description="Documentation for every part of Excerptus." />
      <MarketingNav />
      <div className="px-4 py-10 sm:px-6">
        <HelpLayout>
          <div className="max-w-3xl">
            <h1 className="text-3xl font-bold tracking-tight">Help Center</h1>
            <p className="mt-2 text-muted-foreground">
              Documentation for every part of Excerptus. Pick a topic below, or use the search on the left.
            </p>
            <div className="mt-8 space-y-8">
              {sections.length === 0 && (
                <p className="text-sm text-muted-foreground">
                  No articles yet. They'll appear here as we publish them.
                </p>
              )}
              {sections.map((s) => (
                <section key={s.section}>
                  <h2 className="mb-2 text-lg font-semibold">{s.label}</h2>
                  <ul className="space-y-1">
                    {s.articles.map((a) => (
                      <li key={a.slug}>
                        <Link
                          to={`/help/${a.slug}`}
                          className="text-sm text-foreground underline-offset-2 hover:underline"
                        >
                          {a.title}
                        </Link>
                        {a.summary && (
                          <span className="ml-2 text-sm text-muted-foreground">— {a.summary}</span>
                        )}
                      </li>
                    ))}
                  </ul>
                </section>
              ))}
            </div>
          </div>
        </HelpLayout>
      </div>
      <MarketingFooter />
    </div>
  );
};

export default HelpIndex;
